import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { GET_FILE_HISTORY_WATCHER, DOWNLOAD_FILE_WATCHER } from "./constants"
import {
  getFileHistorySuccess,
  getFileHistoryFailed,
  downloadFileSuccess,
  downloadFileFailed,
} from "./actions"
import { LOCAL_COMPANY_ID } from "../../../utils/storage"

// GET FILE HISTORIES
export function* getFileHistoriesSaga() {
  try {
    const { data, status } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `companies/${LOCAL_COMPANY_ID()}/file-histories`,
    })

    if (status === 200) {
      yield put(getFileHistorySuccess(data.data))
    }
  } catch (error) {
    yield put(getFileHistoryFailed())
    returnMessage(error)
  }
}

// DOWNLOAD FILE
export function* downloadFileSaga(action) {
  try {
    window.message.loading("Descargando archivo...", 1000)
    const response = yield call(fetchGlobalApi, {
      method: "GET",
      responseType: "blob",
      endpoint: `file-histories/${action.payload.idFile}`,
    })
    const url = window.URL.createObjectURL(new Blob([response.data]))

    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", action.payload.nameFile)
    document.body.appendChild(link)
    link.click()

    yield call(window.message.destroy)
    yield call(window.message.success, "Archivo descargado.", 5)
  } catch (error) {
    yield put(downloadFileFailed())
  }
}

// Individual exports for testing
export default function* reminderEmailsSaga() {
  yield takeLatest(GET_FILE_HISTORY_WATCHER, getFileHistoriesSaga)
  yield takeLatest(DOWNLOAD_FILE_WATCHER, downloadFileSaga)
}
